"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SttDoubleListTanstack = _interopRequireDefault(require("./SttDoubleListTanstack"));
var _SttDoubleListFormik = _interopRequireDefault(require("./SttDoubleListFormik"));
var _constantes = require("./constantes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SttDoubleList = function SttDoubleList(_ref) {
  var allItens = _ref.allItens,
    selectedItens = _ref.selectedItens,
    onChange = _ref.onChange,
    getItemText = _ref.getItemText,
    getItemIdentifier = _ref.getItemIdentifier,
    labelLeft = _ref.labelLeft,
    labelRight = _ref.labelRight,
    reset = _ref.reset,
    callbackReset = _ref.callbackReset,
    field = _ref.field,
    form = _ref.form,
    _ref$tipoFormulario = _ref.tipoFormulario,
    tipoFormulario = _ref$tipoFormulario === void 0 ? _constantes.TIPO_FORMULARIO.FORMIK : _ref$tipoFormulario;
  var propsComuns = {
    allItens: allItens,
    selectedItens: selectedItens,
    onChange: onChange,
    getItemText: getItemText,
    getItemIdentifier: getItemIdentifier,
    labelLeft: labelLeft,
    labelRight: labelRight,
    reset: reset,
    callbackReset: callbackReset
  };
  switch (tipoFormulario) {
    case _constantes.TIPO_FORMULARIO.TANSTACK:
      return /*#__PURE__*/_react["default"].createElement(_SttDoubleListTanstack["default"], _extends({}, propsComuns, {
        field: field,
        form: form
      }));
    case _constantes.TIPO_FORMULARIO.FORMIK:
    default:
      return /*#__PURE__*/_react["default"].createElement(_SttDoubleListFormik["default"], propsComuns);
  }
};
var _default = SttDoubleList;
exports["default"] = _default;